<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Készletérték</span>
    </div>
    <div v-loading="loading" class="filter-container">
      <el-form
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="Raktár típusa"
            >
              <el-select
                v-model="storageType"
                value-key="id"
                style="width: 100%;"
                filterable
                multiple
              >
                <el-option
                  label="Központi"
                  value="own"
                />
                <el-option
                  label="Képviselői"
                  value="representative"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Dátum"
            >
              <el-date-picker
                v-model="stockDate"
                style="width: 100%;"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="dateRangeOptions"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div style="text-align: right; margin-top: 24px;">
              <el-button
                :disabled="isDisabled"
                :loading="listLoading"
                icon="el-icon-tickets"
                @click="listStockValue"
              >
                Listázás
              </el-button>
              <el-button
                :disabled="isDisabled"
                :loading="downloadLoading"
                icon="el-icon-download"
                @click="excelExport"
              >
                Letöltés
              </el-button>
              <el-button
                :disabled="isDisabled"
                :loading="printLoading"
                icon="el-icon-printer"
                @click="print"
              >
                Nyomtatás
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <stock-value-list style="margin-top: 30px"/>
  </el-card>
</template>

<script>
import StockValueList from '../../components/reports/stockValue/List';
import moment from 'moment';

export default {
  components: {
    StockValueList,
  },
  data() {
    return {
      loading: false,
      downloadLoading: false,
      printLoading: false,
      filterConfig: null,
      storageType: ['own'],
      stockDate: moment().add(-1, 'day').format('YYYY-MM-DD'),
      productLoading: false,
      product: null,
      products: [],
      selectedEventTypes: ['customerSale', 'customerOrder', 'representativeOrder', 'inwardHandling'],
      eventTypes: [
        { label: 'Bevételezés', value: 'inwardHandling' },
        { label: 'Központi eladás', value: 'customerSale' },
        { label: 'Központi rendelés', value: 'customerOrder' },
        { label: 'Raktárközi rendelés', value: 'representativeOrder' },
      ],
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
    };
  },
  computed: {
    storages() {
      return this.$store.getters['storage/storages'];
    },
    isDisabled() {
      return !this.storageType || !this.stockDate;
    },
    listLoading() {
      return this.$store.getters['stockValue/loading'];
    },
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch('stockValue/fetchAll', `?date=${moment().add(-1, 'day').format('YYYY-MM-DD')}&type=own`);
    this.loading = false;
  },
  methods: {
    async searchProduct(query) {
      if (query !== '') {
        this.productLoading = true;
        this.products = await this.$store.dispatch('product/search', '?name=' + query);
        this.productLoading = false;
      }
    },
    listStockValue() {
      this.$store.dispatch('stockValue/fetchAll', `?type=${this.storageType.join(',')}&date=${moment(this.stockDate).format('YYYY-MM-DD')}`);
    },
    async excelExport() {
      this.downloadLoading = true;
      try {
        const excel = await axios({
          url: 'api/reports/stock-value/download',
          method: 'POST',
          responseType: 'blob',
          data: {
            type: this.storageType.join(','),
            date: moment(this.stockDate).format('YYYY-MM-DD'),
          },
        });
        saveAs(excel, 'stock_value.xlsx');
      } catch (e) {
      }
      this.downloadLoading = false;
    },
    async print() {
      this.printLoading = true;
      const response = await axios.post('api/reports/stock-value/print',  {
        type: this.storageType.join(','),
        date: moment(this.stockDate).format('YYYY-MM-DD'),
      }, {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/pdf'
        },
      });
      this.printLoading = false;

      const newBlob = new Blob([response], { type: 'application/pdf' });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      const data = window.URL.createObjectURL(newBlob);
      window.open(data);
    },
  }
};
</script>

<style lang="scss">
  .filter-container {
    padding: 20px;
    margin: -20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #EBEEF5;
  }
  .el-picker-panel [slot=sidebar], .el-picker-panel__sidebar {
    width: 150px;
  }
  .el-picker-panel [slot=sidebar]+.el-picker-panel__body, .el-picker-panel__sidebar+.el-picker-panel__body {
    margin-left: 150px;
  }
</style>
